import { t } from "@lingui/core/macro"
import { addPageAction } from "../../../../common/newrelic"
import { BaseSuggestedItem } from "../baseSuggestedItem"
import { keywordsSearchClicked } from "../keywordsSuggestedItem"
import { MobileSearchSuggestionClicked } from "./mobileSearchPaneSuggestedItem"
import type { ISuggestionProps } from "../baseSuggestedItem"

export class MobileSearchPaneKeywordsSuggestedItem extends BaseSuggestedItem {
    protected getIconClassName(): string {
        return "icon-keywords"
    }

    protected getStatusText(): string {
        return t`in room subjects and tags`
    }

    protected getRowClassName(): string {
        return "keywordsSuggestion"
    }

    protected onClickHandler(props: ISuggestionProps, evt?: MouseEvent): void {
        evt?.preventDefault()
        keywordsSearchClicked.fire()
        MobileSearchSuggestionClicked.fire()
        addPageAction("KeywordsSearch", { keywords: props.input })
    }
}
